import React from 'react';
import { AnalyticsLink } from '../../Button';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { IButtonAnalyticsProps } from '../../Button/types';

interface IProps extends Pick<IButtonAnalyticsProps, 'trackContext'> {
  reportUrl: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

export default ({ reportUrl, onClick, trackContext }: IProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // KB-6095. Allow Command + Click to Open New Tab
    // special case in Popup Component. If we don't stop propagation, The rightClick/CommandClick won't work
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <BuilderInfoUI.PopupButton
      size="small"
      forwardedAs={AnalyticsLink}
      to={reportUrl}
      onClick={handleClick}
      trackContext={trackContext}
      trackAction="show in report"
    >
      Show in Report
    </BuilderInfoUI.PopupButton>
  );
};
